import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-tabs.css';
import { UitkNavigationType } from './uitk-tabs.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkTabAnchor = /** @class */ (function (_super) {
    __extends(UitkTabAnchor, _super);
    function UitkTabAnchor(props) {
        var _this = _super.call(this, props) || this;
        _this.selectedLiRef = React.createRef();
        _this.preventClickEvent = _this.preventClickEvent.bind(_this);
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        return _this;
    }
    UitkTabAnchor.prototype.handleOnClick = function (event) {
        var _a = this.props, disabled = _a.disabled, handleClick = _a.handleClick, index = _a.index, targetRef = _a.targetRef;
        this.preventClickEvent(event);
        if (disabled) {
            return false;
        }
        if (typeof handleClick === 'function') {
            handleClick(index, event, targetRef);
        }
    };
    UitkTabAnchor.prototype.handleFocus = function (event) {
        var handleFocus = this.props.handleFocus;
        if (typeof handleFocus === 'function') {
            handleFocus(event);
        }
    };
    UitkTabAnchor.prototype.handleBlur = function (event) {
        var handleBlur = this.props.handleBlur;
        if (typeof handleBlur === 'function') {
            handleBlur(event);
        }
    };
    UitkTabAnchor.prototype.preventClickEvent = function (e) {
        var externalLinks = this.props.externalLinks;
        if (!externalLinks) {
            e.preventDefault();
        }
    };
    UitkTabAnchor.prototype.render = function () {
        var _a, _b;
        var _c = this.props, className = _c.className, disabled = _c.disabled, name = _c.name, targetURI = _c.targetURI, panelId = _c.panelId, navigationType = _c.navigationType, selected = _c.selected, tabLinkAttr = _c.tabLinkAttr;
        var wrapperClassNames = getClassNameList('uitk-tab', className, (_a = {},
            _a["active"] = selected,
            _a));
        var anchorClassNames = getClassNameList('uitk-tab-anchor', (_b = {},
            _b["uitk-tab-anchor-selected"] = selected,
            _b["uitk-tab-anchor-disabled"] = disabled,
            _b));
        var isJumplink = navigationType === UitkNavigationType.JUMPLINK;
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        React.createElement("li", { "data-stid": selected ? 'uitk-tab-active' : null, role: isJumplink ? 'listitem' : 'presentation', className: wrapperClassNames, onClick: this.preventClickEvent, ref: selected ? this.selectedLiRef : '' },
            React.createElement("a", __assign({ href: targetURI, className: anchorClassNames }, (!isJumplink && { 'aria-controls': panelId }), (isJumplink ? { 'aria-current': selected } : { 'aria-selected': selected }), tabLinkAttr, { role: isJumplink ? 'link' : 'tab', "data-toggle": "tab", onClick: this.handleOnClick, onFocus: this.handleFocus, onBlur: this.handleBlur, draggable: false }),
                React.createElement("span", { className: getClassNameList('uitk-tab-text') }, name))));
    };
    UitkTabAnchor.displayName = 'UitkTabAnchor';
    return UitkTabAnchor;
}(React.Component));

export { UitkTabAnchor };
